import { ContainerModule } from "inversify";
import { SerializedChoice } from '@xlearn/common';
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import ChoiceQuestionComponent from "./choice-question-component.vue";
import { ChoiceQuestionAnswerProtobufSerializer } from './choice-question-answer-protobuf-serializer'
import { ChoiceQuestionStateProtobufSerializer } from './choice-question-state-protobuf-serializer'
import { customInstruction } from './custom-instruction'

export const choiceQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(ChoiceQuestionComponent)
    .whenTargetNamed("choice");

  const options = { ...Api.defaultQuestionOptions<SerializedChoice>(),
                    customInstruction: customInstruction
                  }

  bind<Api.QuestionOptions<SerializedChoice>>(Api.QuestionOptionsPluginSymbol)
    .toConstantValue(options)
    .whenTargetNamed('choice')

  bind(SerializationApi.StateSerializationPluginSymbol).to(ChoiceQuestionAnswerProtobufSerializer)
  bind(SerializationApi.StateSerializationPluginSymbol).to(ChoiceQuestionStateProtobufSerializer)
});
